import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import Select from 'react-select';
import styled from 'styled-components';
import Input from 'admin/components/shared/Input';
import styles from './styles.scss';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 5px;
`;

export const TextInput = ({ type, required, onChange, maxLength, value, disabled, ...rest }) => (
  <Input
    type={type || null}
    required={required}
    onChange={(e) => { onChange(e.target.value); }}
    maxLength={maxLength}
    value={value}
    disabled={disabled}
    {...rest}
  />
);

export const SelectInput = ({ choices, onChange, required, value, disabled, ...rest }) => (
  <Select
    required={required}
    defaultValue={choices[0]}
    options={choices}
    onChange={(e) => { onChange(e.value); }}
    value={value}
    isDisabled={disabled}
    {...rest}
  />
);

export const FormList = CSSModules(
  ({ columns }) => {
    return (
      <div>
        {
          columns.map(({ title, form, alert, id }) => {
            return (
              <Row styleName="row" key={id ?? title}>
                <div styleName="label">{title}</div>
                <div styleName="form-item">
                  {form}
                </div>
                {alert}
              </Row>
            );
          })
        }
      </div>
    );
  },
  styles
);

const ModalWrapper = styled.div`
  max-height: calc(100vh - 210px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-left: solid 1px #ececec;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
    box-shadow: inset 0 0 0 2px #fff;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 10px 16px;
    text-align: left;
    vertical-align: top;
    line-height: 1.5;
    border-top: 1px solid #eee;

    :first-child {
      padding-left: 0;
      width: 45%;
      color: #555;
      font-weight: 600;
    }

    :last-child {
      padding-right: 0;
      word-break: break-word;
    }
  }

  tr:first-child td {
    border-top: none;
  }
`;

export const FormPreview = ({ message, columns }) => (
  <div>
    <p>{message}</p>
    <ModalWrapper>
      <Table>
        <tbody>
          {
            columns.map(({ title, ref }) => (
              <tr key={title}>
                <td>{title}</td>
                <td>{ref()}</td>
              </tr>
            ))
          }
        </tbody>
      </Table>
    </ModalWrapper>
  </div>
);
